/*
 * @Author: Alex Sorafumo
 * @Date:   2017-05-02 16:51:45
 * @Last Modified by:   Alex Sorafumo
 * @Last Modified time: 2017-05-05 11:07:01
 */

import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef, NgZone } from '@angular/core';
import { animate, keyframes, state, style, transition, trigger } from '@angular/animations';

import { BaseWidgetComponent } from '../../../shared/base.component';

@Component({
    selector: 'media-player',
    template: `<div #video  [class]="'media-player' + (klass ? ' ' + klass : '')" widget (contextmenu)="$event.preventDefault()" (mousemove)="showTools()" (touchrelease)="changeMediaState();showTools()" (dblclick)="toggleFullScreen()" (press)="navigate($event)" (panmove)="navigate($event)">
    <video #player autoplay x-webkit-airplay="allow"><source [src]="src" type="video/mp4"/></video>
    <div class="status-buttons" *ngIf="!media_playing">
        <div class="status">
            <div class="icon white" [class.play]="!is_end" [class.replay]=" is_end"></div>
        </div>
    </div>
    <div class="video-controls" [@controls]="controls_active ? 'show' : 'hide'" (mouseleave)="showTools()">
        <div class="playback">
            <div class="icon white" [class.play]="!media_playing && !is_end" [class.replay]="!media_playing && is_end" [class.pause]="media_playing"></div>
        </div>
        <div class="time now">{{ current_time }}</div>
        <div class="time end">{{ duration }}</div>
        <div class="progress-bar">
            <div class="progress" [style.width]="progress + '%'" [style.background-color]="color"></div>
            <div class="knob" [class.hide]="!controls_active" [style.left]="progress + '%'">
                <div></div>
            </div>
        </div>
    </div>
</div>
`,
    styles: [`.media-player{background-color:#000;height:100%;min-height:10em;min-width:16em;overflow:hidden;position:relative;width:100%}video{height:100%;left:50%;position:absolute;top:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);width:100%}.status-buttons{position:absolute;top:0;left:0;right:0;bottom:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;background-color:rgba(0,0,0,.54)}.status{font-size:2em;-webkit-box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12);box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12);border-radius:100%}.video-controls{background-color:rgba(0,0,0,.87);left:0;right:0;bottom:0;color:#fff;display:-webkit-box;display:-ms-flexbox;display:flex;height:2em;padding:.25em .5em .25em 0;position:absolute;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.time{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.time.end{text-align:right}.progress-bar{background-color:#fff;height:.2em;left:0;position:absolute;right:0;top:0}.progress-bar .progress{bottom:0;left:0;position:absolute;top:0}.progress-bar .knob{position:absolute;top:50%;height:0;width:0;opacity:1;-webkit-transition:opacity .3s;transition:opacity .3s}.progress-bar .knob.hide{opacity:0}.progress-bar .knob div{position:absolute;height:1em;width:1em;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);background-color:#f0f0f0;border-radius:100%;-webkit-box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12);box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12)}.icon{margin:.25em;height:1.5em;width:1.5em;background-position:center;background-size:contain;background-repeat:no-repeat}.icon.play{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxwYXRoIGQ9Ik04IDV2MTRsMTEtN3oiLz4KICAgIDxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiLz4KPC9zdmc+Cg==)}.icon.stop{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiLz4KICAgIDxwYXRoIGQ9Ik02IDZoMTJ2MTJINnoiLz4KPC9zdmc+Cg==)}.icon.pause{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxwYXRoIGQ9Ik02IDE5aDRWNUg2djE0em04LTE0djE0aDRWNWgtNHoiLz4KICAgIDxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiLz4KPC9zdmc+Cg==)}.icon.replay{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiLz4KICAgIDxwYXRoIGQ9Ik0xMiA1VjFMNyA2bDUgNVY3YzMuMzEgMCA2IDIuNjkgNiA2cy0yLjY5IDYtNiA2LTYtMi42OS02LTZINGMwIDQuNDIgMy41OCA4IDggOHM4LTMuNTggOC04LTMuNTgtOC04LTh6Ii8+Cjwvc3ZnPgo=)}.icon.white.play{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSIjZmZmIj4KICAgIDxwYXRoIGQ9Ik04IDV2MTRsMTEtN3oiLz4KICAgIDxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiLz4KPC9zdmc+Cg==)}.icon.white.stop{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSIjZmZmIj4KICAgIDxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiLz4KICAgIDxwYXRoIGQ9Ik02IDZoMTJ2MTJINnoiLz4KPC9zdmc+Cg==)}.icon.white.pause{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSIjZmZmIj4KICAgIDxwYXRoIGQ9Ik02IDE5aDRWNUg2djE0em04LTE0djE0aDRWNWgtNHoiLz4KICAgIDxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiLz4KPC9zdmc+Cg==)}.icon.white.replay{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSIjZmZmIj4KICAgIDxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiLz4KICAgIDxwYXRoIGQ9Ik0xMiA1VjFMNyA2bDUgNVY3YzMuMzEgMCA2IDIuNjkgNiA2cy0yLjY5IDYtNiA2LTYtMi42OS02LTZINGMwIDQuNDIgMy41OCA4IDggOHM4LTMuNTggOC04LTMuNTgtOC04LTh6Ii8+Cjwvc3ZnPgo=)}`],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        trigger('controls', [
            state('show', style({ bottom: '0' })),
            state('hide', style({ bottom: '-1.8em' })),
            transition('show <=> hide', animate('0.4s ease-out')),
        ]),
    ],
})
export class MediaPlayerComponent extends BaseWidgetComponent {
    @Input() public src: string = null;
    @Input() public color = '#2196F3';
    @Input() public autoplay = false;

    @Output() public time = new EventEmitter<string>();
    @Output() public length = new EventEmitter<string>();
    @Output() public event: any = new EventEmitter();

    public timer: number;
    public progress = 0;
    public current_time = '00:00';
    public duration = '00:00';
    public start: number = (new Date()).getTime();
    public media_playing = false;
    public controls_active = true;
    public is_end = false;

    private hide_timer: any = null;

    @ViewChild('video') private video: ElementRef;
    @ViewChild('player') private player: ElementRef;

    constructor(private cdr: ChangeDetectorRef, private zone: NgZone) {
        super();
    }

    public ngAfterViewInit() {
        this.init();
    }

    public change() {
        this.zone.run(() => this.cdr.markForCheck());
    }

    public changeMediaState() {
        if (this.media_playing) {
            this.stopMedia();
        } else {
            this.playMedia();
        }
    }

    public playMedia() {
        this.media_playing = true;
        this.player.nativeElement.play();
        this.setDuration();
        this.showTools();
        this.event.emit({ type: '', event: 'play' });

        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
        this.timer = <any>setInterval(() => this.updateTimer(), 50);
    }

    public stopMedia(emit: boolean = true) {
        this.media_playing = false;
        this.player.nativeElement.pause();
        if (emit) { this.event.emit({ type: '', event: 'stop' }); }

        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    }

    public restartMedia() {
        this.player.nativeElement.play();
        this.player.nativeElement.currentTime = 0;
        this.event.emit({ type: '', event: 'restart' });
    }

    public showTools() {
        this.controls_active = true;
        this.timeout('hide', () => {
            if (this.media_playing) {
                this.controls_active = false;
            }
        }, 3000);
    }

    public updateTimer() {
        if (!this.player) {
            return;
        }
        const time = this.player.nativeElement.currentTime;
        const secs = Math.floor(time % 60);
        const mins = Math.floor(time / 60);
        this.current_time = `${mins < 10 ? '0' + mins : mins}:${secs < 10 ? '0' + secs : secs}`;
        this.time.emit(this.current_time);
        this.progress = this.player.nativeElement.currentTime / this.player.nativeElement.duration * 100;
        this.is_end = this.player.nativeElement.currentTime === this.player.nativeElement.duration;
        if (this.is_end) {
            this.stopMedia(false);
            this.event.emit({ type: '', event: 'reached_end' });
        }
        this.change();
    }

    public setDuration() {
        if (!this.player) {
            return;
        }
        const time = this.player.nativeElement.duration;
        const secs = Math.floor(time % 60);
        const mins = Math.floor(time / 60);
        if (isNaN(secs) || isNaN(mins)) {
            return this.timeout('duration', () => this.setDuration(), 200);
        }
        this.duration = `${mins < 10 ? '0' + mins : mins}:${secs < 10 ? '0' + secs : secs}`;
        this.length.emit(this.duration);
    }

    public toggleFullScreen() {
        const doc: any = window.document;
        const docEl: any = this.video.nativeElement;

        const requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen
            || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen;
        const cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen
            || doc.webkitExitFullscreen || doc.msExitFullscreen;

        if (!doc.fullscreenElement && !doc.mozFullScreenElement
            && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {

            requestFullScreen.call(docEl);
        } else {
            cancelFullScreen.call(doc);
        }
    }

    public navigate(event: any) {
        if (event.center && this.video && this.video.nativeElement) {
            const box = this.video.nativeElement.getBoundingClientRect();
            const percent = (event.center.x - box.left) / box.width;
            if (this.player) {
                this.player.nativeElement.currentTime = this.player.nativeElement.duration * percent;
            }
            this.updateTimer();
        }
    }

    private init() {
        if (!this.player) {
            this.timeout('init', () => this.init(), 200);
        } else {
            if (this.autoplay) {
                this.playMedia();
            } else {
                this.stopMedia();
            }
        }
    }
}
